// extracted by mini-css-extract-plugin
module.exports = {"warning":"style-module__warning___y_-bQ"};